<template>
    <i 
        :class="'chill-icons ' + size + (!fill && active ? ' text-primary': '')"
        @mouseover="status = 'filled'"
        @mouseleave="status = 'circle'"
        @click="$emit('click')"
    >
        {{ fill ? icon + '_' + active ? 'filled' : status : icon }}
    </i>
</template>

<script>
    export default {
        name: 'chillIcon',
        props: {
            icon: String,
            fill: Boolean,
            active: Boolean,
            size: String
        },
		data () {
			return {
				status: 'circle',
			}
		}
    }
</script>

<style scoped>
    @font-face {
    font-family: 'Chill Icons';
    src:
        url('../assets/fonts/ChillServicesIcons.ttf') format('ttf'),
        url('../assets/fonts/ChillServicesIcons.eot') format('eot'),
        url('../assets/fonts/ChillServicesIcons.svg') format('svg'),
        url('../assets/fonts/ChillServicesIcons.woff2') format('woff2'),
        url('../assets/fonts/MaterialIcons-RegularFix.woff2') format('woff2'),
        url('../assets/fonts/MaterialIcons-RegularFix.ttf') format('ttf'),
        url('../assets/fonts/ChillServicesIcons.woff') format('woff');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'Material Chill Icons';
    src:
        url('../assets/fonts/MaterialIcons-RegularFix.woff2') format('woff2'),
        url('../assets/fonts/MaterialIcons-RegularFix.ttf') format('ttf');
    font-weight: normal;
    font-style: normal;
}


.material-chill-icons {
    font-family: 'Material Chill Icons';
    font-weight: normal;
    font-style: normal;
    display: inline-block;
    line-height: 1;
    text-transform: none;
    letter-spacing: normal;
    word-wrap: normal;
    white-space: nowrap;
    direction: ltr;

    /* Support for all WebKit browsers. */
    -webkit-font-smoothing: antialiased;
    /* Support for Safari and Chrome. */
    text-rendering: optimizeLegibility;

    /* Support for Firefox. */
    -moz-osx-font-smoothing: grayscale;

    /* Support for IE. */
    font-feature-settings: 'liga';
}
.chill-icons-local {
    height: 20px;
}
.chill-icons {
    font-family: 'Chill Icons';
    font-weight: normal;
    font-style: normal;
    display: inline-block;
    line-height: 1;
    text-transform: none;
    letter-spacing: normal;
    word-wrap: normal;
    white-space: nowrap;
    direction: ltr;
    margin-top: auto;
    margin-bottom: auto;

    /* Support for all WebKit browsers. */
    -webkit-font-smoothing: antialiased;
    /* Support for Safari and Chrome. */
    text-rendering: optimizeLegibility;

    /* Support for Firefox. */
    -moz-osx-font-smoothing: grayscale;

    /* Support for IE. */
    font-feature-settings: 'liga';
}

.icon.lg{
    font-size: 34px;
}

.slug-icon {
    color: #1B608C;
}
.warning {
    color: #E16369;
}
.medium-icon {
    font-size: 20px;
    margin-bottom: 4px;
}
.big-icon {
    font-size: 28px;
    margin-bottom: 4px;
}
</style>